import * as yup from 'yup';

export const initialValues = {
    id: null,
    checkExperience: false,
    company: '',
    startDate: '',
    endDate: '',
    checkActualJob: false,
    sector: '',
    activities: '',
    latestRole: ''
}

const schema = 
yup.object().shape({
    checkExperience: yup.boolean(),
    company: yup.string()
    .when('checkExperience', {
        is: true,
        then: schema => schema.nullable(),
        otherwise: schema => schema.required('Empresa é obrigatório')
    }),
    startDate: yup.string()
    .when('checkExperience', {
        is: true,
        then: schema => schema.nullable(),
        otherwise: schema => schema.matches(/([0-9]{2}\/[0-9]{4})/, {message:'Data de início é obrigatório!', excludeEmptyString:true}).required('Data de início é obrigatório!')
    }),
    checkActualJob: yup.boolean(),
    endDate: yup.string().nullable()
    .when(['checkExperience', 'checkActualJob'], {
        is: false,
        then:  schema => schema.matches(/([0-9]{2}\/[0-9]{4})/, {message:'Data de término é obrigatório!', excludeEmptyString:true}).required('Data de término é obrigatório!') ,
        otherwise: schema => schema.nullable(),
    }),
    sector: yup.string()
    .when('checkExperience', {
        is: true,
        then: schema => schema.nullable(),
        otherwise: schema => schema.required('Área de ocupação é obrigatória!')
    }),
    activities: yup.string()
    .when('checkExperience', {
        is: true,
        then: schema => schema.nullable(),
        otherwise: schema => schema.required('Atividades é obrigatório!')
    }),
    latestRole: yup.string(),
})

export default schema